import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDove } from '@fortawesome/free-solid-svg-icons/faDove';
import type { IconProps } from '../../types';

export function DoveIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Dove',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faDove}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
